import React, { useEffect, useState } from "react";
import { MdWifiOff, MdClose } from "react-icons/md";
import { subscribeSlowNetwork } from "../../lib/utils/slowNetwork";

const SlowNetworkOverlay: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  // Dismissed by the user via the × — stays hidden until the next slow-network signal.
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    return subscribeSlowNetwork((slow) => {
      setIsVisible(slow);
      if (slow) setDismissed(false); // a fresh slow-network event re-shows the tag
    });
  }, []);

  if (!isVisible || dismissed) return null;

  return (
    <div className="fixed top-4 right-4 z-[100] flex items-center gap-2.5 bg-white border border-gray-300 rounded-lg shadow-lg pl-3 pr-2 py-2 max-w-xs">
      <MdWifiOff className="text-lg text-red-500 shrink-0" />
      <p className="text-sm font-semibold text-gray-800 whitespace-nowrap">
        Internet connection is slow
      </p>
      <button
        type="button"
        onClick={() => setDismissed(true)}
        aria-label="Dismiss"
        className="shrink-0 text-gray-400 hover:text-gray-700 rounded p-0.5"
      >
        <MdClose className="text-base" />
      </button>
    </div>
  );
};

export default SlowNetworkOverlay;
